






















import SubmitBtn from '@/components/Common/SubmitBtn.vue';
import StatementAccountInfo from '../StatementAccountInfo.vue';
import { Component, Vue, Prop, ModelSync, Watch } from 'vue-property-decorator';
import { previewFile } from '@/utils/function_utils';
import { deleteFileApi } from '@/api/index'

@Component({
  name: 'settlingFileListDialog',
  components: {
    SubmitBtn,
    StatementAccountInfo,
  }
})
export default class extends Vue {
  @ModelSync('dialogFileListVisible', 'changeVisible', { type: Boolean })
  public value!: boolean;

  @Prop() public readonly fileList!: any;

  public handlePreviewFile = previewFile;

  public async deleteFile(file: any) {
    await deleteFileApi(file.fkFileGuid)
  }

  public handleClose() {
    this.$emit("changeVisible", false);
  }
}
